var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 135 135",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4676ed;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Graphic_Elements",
    "data-name": "Graphic Elements"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M135,67.5a67.5,67.5,0,1,0-78,66.68V87H39.81V67.5H57V52.63C57,35.71,67,26.37,82.45,26.37a103.77,103.77,0,0,1,15.11,1.32V44.3H89.05c-8.39,0-11,5.2-11,10.54V67.5H96.77L93.77,87H78.05v47.17A67.51,67.51,0,0,0,135,67.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M93.77,87l3-19.51H78.05V54.84c0-5.34,2.61-10.54,11-10.54h8.51V27.69a103.77,103.77,0,0,0-15.11-1.32C67,26.37,57,35.71,57,52.63V67.5H39.81V87H57v47.17a68.28,68.28,0,0,0,21.1,0V87Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/FB.3bd163b1700c7ce5a3c22c1206d63844.svg";
export { ForwardRef as ReactComponent };